import * as React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import * as ReactDom from 'react-dom';
import OverviewPage from './overviewPage';
import ServicePage from './servicePage';
import CountriesPage from './countriesPage/index';
import FilterPage from './filterPage';
import WizardPage from './wizardPage/index';
import FilterMobilePage from './filterMobilePage/index';

export class LayoutPage extends React.Component<{}, {}>
{
	constructor(props: any) {
		super(props);
	}

	public render(): JSX.Element {
		return (
			<div className="layout">
				<div className="row">
					<div className="filter-col">
						<FilterPage />
					</div>
					<div className="position-col-reset">
						<Route exact path="/" component={OverviewPage} />
						<Route path="/service/:code" component={ServicePage} />
						<Route path="/childservice/:parentcode/:code" component={ServicePage} />
					</div>
				</div>
				<CountriesPage />
				<WizardPage />
				<FilterMobilePage />
			</div>
		);
	}
}

